fragment NutshellMarketingStats on NutshellMarketingStats {
    usageStats {
        numberOfEmailsSentThisMonth
        numberOfMarketableContacts
    }
    gate {
        maxNumberOfEmailsPerMonth
        maxNumberOfMarketableContacts
        marketingContactsOverageAllowance
        hasUnlimitedMarketingContacts
        hasOveragesEnabledFromWebfx
    }
}
